import { render, staticRenderFns } from "./WelcomeForm.vue?vue&type=template&id=13af18ab"
import script from "./WelcomeForm.vue?vue&type=script&lang=js"
export * from "./WelcomeForm.vue?vue&type=script&lang=js"
import style0 from "./WelcomeForm.vue?vue&type=style&index=0&id=13af18ab&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports